import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Modal } from "@/components/General/Modal/modal";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    inactivityCountdown: number;
    modalState: boolean;
    toggleHandler: (newState: boolean) => void;
    logoutUser: () => void;
};

const InactivityMonitor = ({
    inactivityCountdown,
    modalState,
    toggleHandler,
    logoutUser
}: Props) => {
    const { t } = useGranite();
    return (
        <Modal
            modalType={ModalType.InactivityMonitor}
            title={t("ecorner.inactivityModal.title")}
            autoFocus={false}
            centered={true}
            size={"sm"}
            open={modalState}
            setOpen={toggleHandler}
            closable={true}
            withFooter={false}
        >
            {t("ecorner.inactivityModal.text", inactivityCountdown)}
            <div
                className={cn(
                    "tw:flex tw:w-full tw:m-0 tw:mt-2 tw:sm:mt-3 tw:items-center tw:justify-between"
                )}
            >
                <Button
                    test="inactivityMonitor-button-cancel"
                    type="button"
                    onClick={() => toggleHandler?.(false)}
                >
                    {t("ecorner.inactivityModal.button.cancel")}
                </Button>
                <Button
                    test="inactivityMonitor-button-submit"
                    color={"gray"}
                    type="button"
                    onClick={() => logoutUser?.()}
                >
                    {t("ecorner.inactivityModal.button.logout")}
                </Button>
            </div>
        </Modal>
    );
};

export default InactivityMonitor;
